var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginBgShapes02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 295 518",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Artboard1",
    transform: "matrix(0.777856,0,0,1,-103.877,6.33402)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.542,
    y: -6.334,
    width: 378.634,
    height: 517.982,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.542,
    y: -6.334,
    width: 378.634,
    height: 517.982
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.986301,1.22465e-16,1.20787e-16,1,622.468,-6.2227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.926,208.456L135.53,13.76C122.396,4.762 109.162,0 98.163,0C76.897,0 63.743,17.067 63.743,45.635L63.743,466.431C63.743,494.966 76.881,512 98.096,512C109.112,512 122.134,507.234 135.297,498.211L419.826,303.519C438.124,290.978 448.257,274.101 448.257,255.977C448.262,237.866 438.244,220.993 419.926,208.456Z",
    style: {
      fill: "rgba(0,0,0,0.45)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.14px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBgShapes02);
export default __webpack_public_path__ + "static/media/login-bg-shapes-02.7d7f8c0a4677dde9fbbc19b2def994e9.svg";
export { ForwardRef as ReactComponent };